// ponytail: stand-in for the <dynamic-dates> element from Shrine Pro's missing scripts. Counts calendar days, not business days.
function formatDynamicDate(date, format, days, months) {
  const d = date.getDate();
  const day = days[(date.getDay() + 6) % 7]; // labels start on Monday
  const month = months[date.getMonth()];
  const ordinal = d + ([11, 12, 13].includes(d % 100) ? 'th' : ['th', 'st', 'nd', 'rd'][d % 10] || 'th');
  const pad = (n) => String(n).padStart(2, '0');
  const numeric = `${pad(d)}. ${pad(date.getMonth() + 1)}.`;
  return {
    day_mm_dd: `${day}, ${month} ${ordinal}`,
    day_dd_mm: `${day}, ${d}. ${month}`,
    mm_dd: `${month} ${ordinal}`,
    dd_mm: `${d}. ${month}`,
    dd_mm_no_dot: `${d} ${month}`,
    day_dd_mm_numeric: `${day}, ${numeric}`,
    dd_mm_numeric: numeric,
  }[format] || `${month} ${ordinal}`;
}

if (typeof customElements !== 'undefined' && !customElements.get('dynamic-dates')) {
  customElements.define('dynamic-dates', class extends HTMLElement {
    connectedCallback() {
      const split = (s) => (s || '').split(',').map((x) => x.trim());
      const days = split(this.dataset.dayLabels);
      const months = split(this.dataset.monthLabels);
      const inDays = (n) => {
        const date = new Date();
        date.setDate(date.getDate() + (parseInt(n, 10) || 0));
        return formatDynamicDate(date, this.dataset.dateFormat, days, months);
      };
      this.querySelectorAll('[data-dynamic-date="true"]').forEach((el) => {
        el.innerHTML = el.dataset.text
          .replaceAll('[start_date]', inDays(el.dataset.minDays))
          .replaceAll('[end_date]', inDays(el.dataset.maxDays));
      });
    }
  });
}
